export const divider = {
  root: {
    borderColor: '{surface.500}',
  },
  horizontal: {
    padding: '0',
    margin: '0',
  },
  vertical: {
    padding: '0',
    margin: '0',
  },
}
